import { styled, selectTheme } from '@creditas-ui/react';
import { GridContainer } from '@creditasmx-utilities/components';

export const StyledGridContainer = styled(GridContainer)`
  max-width: ${selectTheme('breakpoints.7xl')};
  margin: 0 auto;
  @media (max-width: ${selectTheme('breakpoints.3xl')}) {
    display: flex;
    flex-direction: column;
    padding-top: 40px;
  }
  @media (min-width: ${selectTheme('breakpoints.8xl')}) {
    grid-template-rows: 140px auto;
  }
`;
